import {Injectable} from '@angular/core';

import {StoreConfig} from '@datorama/akita';
import {GridStore} from '@q9elements/ui-kit/components';

import {MyMetadataEntity} from './my-metadata-entity';

@Injectable({providedIn: 'root'})
@StoreConfig({name: 'my-metadata', idKey: '_id', resettable: true})
export class MyMetadataStore extends GridStore<MyMetadataEntity> {
  constructor() {
    super({
      type: '',
      sort: [{dir: 'desc', field: 'id'}]
    });
  }
}
